export const emitEventFP = (name, params, _standard) => {
    try {
        window.parent.postMessage({
            type: 'streamchat:fb-event',
            payload: { name, params }
        }, '*');
    } catch (e) {
        console.error(e)
    }
}
